import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
import {encrypt,decrypt } from '@utils/local-storage'
import store from '@state/store'
import { isNumber } from 'lodash'
import jwt_decode from "jwt-decode"

let serverUrl = getSecret('SERVER_MASTER_URL')

export const state = {
  cached: {},
  variableIcons: [{ key: 'text', value: 'file-font' },
  { key: 'integer', value: 'hash' },
  { key: 'decimal', value: 'hash' },
  { key: 'alphanumeric', value: 'type' },
  { key: 'image', value: 'card-image' },
  { key: 'file', value: 'file-richtext' },
  { key: 'address', value: 'geo-alt' },
  { key: 'email', value: 'at' },
  { key: 'date', value: 'calendar2-minus' },
  { key: 'time', value: 'clock' },
  { key: 'list', value: 'list-task' },
  { key: 'boolean', value: 'toggle-on' }],
  dimensions_cached: []
}

export const getters = {
  getVariableIcons(state) {
    return state.variableIcons
  },
  dimensions_cached: state => {
    const dimensions_cached = getSavedState('dimensions_cached')
    if (Object.keys(state.dimensions_cached).length === 0 && Object.keys(dimensions_cached) > 0) {
      return dimensions_cached
    }
    return state.dimensions_cached
  }
}

export const mutations = {
  CACHE_DIMENSIONS(state, dimensions) {
    saveState('dimensions_cached', dimensions);
    state.dimensions_cached = dimensions
  },
}

export const actions = {
  getVariables(context, query, variableId) {
    query = query ? (isNumber(query) ? query + '/' : query) : ''
    let id = variableId ? variableId + '/' : ''
    return axios.get(`${serverUrl}/api/variables/${id}${query}`).then((response) => {
      return response.data
    })
  },

  getVariablesList(context, payload) {
    let query = payload.query || ''
    return axios.get(`${serverUrl}/api/variables/${query}`).then((response) => {
      return response.data
    })
  },

  createVariable(context, formData) {
    let promise = null
    if (formData.id !== null) {
      promise = axios.put(`${serverUrl}/api/variables/${formData.id}/`, formData)
    } else {
      promise = axios.post(`${serverUrl}/api/variables/`, formData)
    }
    return promise.then((response) => {
      saveState('dimensions_cached', [])
      return response.data
    })
  },
  deleteVariable(context,variable) {
    let promise = null
    promise = axios.delete(`${serverUrl}/api/variables/${variable.id}/?validation=${variable.validate}`)
    return promise.then((response) => {
      return response.data
    })
  },

  getDimensions({ commit }, query = '') {
    query = query || ''
    return axios.get(`${serverUrl}/api/dimensions/${query}`).then((response) => {
      commit('CACHE_DIMENSIONS', response.data)
      return response.data
    }).catch((err) => {
      console.log(err)
      store.dispatch('utils/message', {
        type: 'error',
        title: 'Error',
        text: 'Error consultando dimensiones',
      })
      return err.response
    })
  },
  getDimensionsPoll({ commit }, query = '') {
    query = query || ''
    return axios.get(`${serverUrl}/api/pollsdimensions/${query}`).then((response) => {
      commit('CACHE_DIMENSIONS', response.data)
      return response.data
    }).catch((err) => {
      store.dispatch('utils/message', {
        type: 'error',
        title: 'Error',
        text: 'Error consultando dimensiones',
      })
      return err.response
    })
  },

  getDimensionsNoToken({ commit }, data) {
    data.query = data.query || ''
    let decoded = jwt_decode(data.token);
    data.query += `&user_id=${decoded.user_id}`
    return axios.get(`${serverUrl}/api/dimensions/${data.query}`, {
      headers: {
        'Authorization': `key ${data.token}`
      }
    }).then((response) => {
      return response.data
    }).catch((err) => {
      store.dispatch('utils/message', {
        type: 'error',
        title: 'Error',
        text: 'Error consultando dimensiones',
      })
      return err.response
    })
  },

  getMeasureUnits() {
    return axios.get(`${serverUrl}/api/measure_units/`).then((response) => {
      return response.data
    })
  },
  getPrivacyLevels() {
    return axios.get(`${serverUrl}/api/privacy_levels/`).then((response) => {
      return response.data
    })
  }
}


// ===
// Private helpers
// ===

function getSavedState(key) {
  console.log('getSavedState',key)
  key = getCurrentSessionUser().user.username + '.' + key
  return getStateLocalStorage(key)
}
function saveState(key, state) {
  key = getCurrentSessionUser().user.username + '.' + key
  saveStateLocalStorage(key, state)
}

function removeFromStorage(key, item) {
  let records = getSavedState(key).filter((x) => { return String(x.key) !== String(item) })
  saveState(key, records)
}

function getCurrentSessionUser() {
  let user = getStateLocalStorage('auth.currentSession')
  if (user == null || user.length < 0) {
    user = JSON.parse('[{"user":{"username":"","id":0}}]')
  }
  return user
}

function getStateLocalStorage(key) {
  let storage = window.localStorage.getItem(key)
  if (storage != null) {
    if (typeof (storage) == Object && storage.length < 0) {
      return JSON.parse('[]')
    }
    return JSON.parse(decrypt(storage))
  } else {
    return JSON.parse('[]')
  }
}

function saveStateLocalStorage(key, state) {
  window.localStorage.setItem(key, encrypt(JSON.stringify(state)))
  // window.localStorage.setItem(key, (JSON.stringify(state)))
}

